function clamp01(x: number) {
  return Math.max(0, Math.min(1, x));
}

function hexToRgb(hex: string) {
  const m = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  if (!m) return null;
  return {
    r: parseInt(m[1], 16),
    g: parseInt(m[2], 16),
    b: parseInt(m[3], 16),
  };
}

function rgbToHex(r: number, g: number, b: number) {
  const toHex = (n: number) => n.toString(16).padStart(2, "0");
  return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
}

/**
 * Aclara un color hex mezclándolo con blanco en proporción t (0..1).
 * t = 0 -> sin cambio, t = 1 -> blanco puro.
 */
export function lightenHex(hex: string, t: number) {
  const c = hexToRgb(hex);
  if (!c) return hex;
  t = clamp01(t);
  const r = Math.round(c.r + (255 - c.r) * t);
  const g = Math.round(c.g + (255 - c.g) * t);
  const b = Math.round(c.b + (255 - c.b) * t);
  return rgbToHex(r, g, b);
}

/**
 * Deriva 3 stops de gradiente a partir del brand.
 * Ajusta los factores si quieres más/menos contraste.
 */
export function deriveGradientsFromBrand(brandHex: string) {
  const grad1 = lightenHex(brandHex, 0.35);
  const grad2 = lightenHex(brandHex, 0.55);
  const grad3 = lightenHex(brandHex, 0.75);
  return { grad1, grad2, grad3 };
}
